import { COMPLETE_ACCOUNT_FAIL, COMPLETE_ACCOUNT_REQUEST, COMPLETE_ACCOUNT_SUCCESS, DISMISS_MODAL } from './actions';
import { createSelector } from '@reduxjs/toolkit';
import { getAuthToken, getBidderEmail } from './user';
import { getCompleteAccountAnalytics } from './analytics';
import { getDeployment } from './config';
import { getSeller } from './seller';
import { getSellerUrl } from '@/utils/urls';
import { getSignupFromFlattenTheCurvePage, getSignupReferralHouse } from './modal';
import { GlobalState } from '../rootReducer';
import { postUpdateProfile, UpdateProfileRequest } from '@/redux/api/bidder';
import { push } from 'connected-react-router';
import CountriesWithISOCodes from '@liveauctioneers/caterwaul-components/lib/Intl/CountriesWithISOCodes';

// reducer
export const DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DISMISS_MODAL:
            return {
                ...state,
                error: false,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case COMPLETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.completeAccount;

export const getUiCompleteAccount = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const submitCompleteAccount =
    (updatedProfile: UpdateProfileRequest) => async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);
            // email is not set in the complete account form, it comes from the token at this point
            updatedProfile.email = getBidderEmail(state);

            // I think country at this point is a full name, we need to send the code and name to the api
            const countryValue = CountriesWithISOCodes.find((c) => c.name === updatedProfile.country);
            if (countryValue && countryValue.code3) {
                updatedProfile.countryCode = countryValue.code3;
            }

            dispatch({
                type: COMPLETE_ACCOUNT_REQUEST,
            });
            const response = await postUpdateProfile({
                authToken,
                deployment,
                profile: updatedProfile,
            });

            dispatch({
                meta: { ...getCompleteAccountAnalytics(), actionTime: Date.now() },
                payload: response.payload,
                type: COMPLETE_ACCOUNT_SUCCESS,
            });

            const signupReferralHouse = getSignupReferralHouse(state);
            const signupFromFlattenTheCurvePage = getSignupFromFlattenTheCurvePage(state);
            const seller = getSeller(state, signupReferralHouse);

            if (signupFromFlattenTheCurvePage) {
                if (seller.name) {
                    dispatch(push(getSellerUrl(seller.sellerId, seller.name)));
                } else {
                    dispatch(push('/'));
                }
            }
        } catch (error) {
            dispatch({
                error: true,
                payload: error,
                type: COMPLETE_ACCOUNT_FAIL,
            });
        }
    };
